import { appAxios } from "app/tools/axios/axios";

import { User } from "../../entity";

export const readUser = async (): Promise<User> => {
  const response = await appAxios.get("user");
  return response.data.user;
};
